module.exports = __webpack_public_path__ + "static/media/aboutusheroimg.d6001f7a.webp";